import { createAction, createSlice } from '@reduxjs/toolkit';
import { IChartData } from '../hooks/useGraph';

type TChart = {
  chartData: IChartData | null;
  period: string | null;
  dates: Date[] | null;

  chartTypeLabel: string;
  chartMetricLabel: string;
};

const initialState: TChart = {
  chartData: null,
  period: null,
  dates: null,

  chartMetricLabel: '',
  chartTypeLabel: '',
};

export const setChartData = createAction<IChartData | null>(
  'chart/setChartData'
);
export const setChartCaption = createAction<{
  chartTypeLabel: string;
  chartMetricLabel: string;
}>('chart/setChartCaption');
const chartSlice = createSlice({
  name: 'chart',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setChartData, (state, { payload }) => {
        if (payload && typeof payload === 'object') {
          state.chartData = payload;
        }
      })
      .addCase(setChartCaption, (state, { payload }) => {
        if (payload && typeof payload === 'object') {
          state.chartTypeLabel = payload.chartTypeLabel;
          state.chartMetricLabel = payload.chartMetricLabel;
        }
      });
  },
});

export default chartSlice.reducer;
